/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "customFields": {
    "HCAPTCHA_SITEKEY": "3262e7ec-0f20-4d12-ace4-e30cd2a2f7a0"
  },
  "title": "EasyLayer.io",
  "tagline": "Self-hosted framework for building blockchain state services and custom indexers.",
  "favicon": "img/favicon.ico",
  "url": "https://easylayer.io",
  "baseUrl": "/",
  "organizationName": "EasyLayer",
  "projectName": "easylayer",
  "onBrokenLinks": "throw",
  "onBrokenMarkdownLinks": "warn",
  "trailingSlash": true,
  "i18n": {
    "defaultLocale": "en",
    "locales": [
      "en",
      "ua"
    ],
    "localeConfigs": {
      "ua": {
        "label": "Українська",
        "direction": "ltr",
        "htmlLang": "uk-UA",
        "calendar": "gregory",
        "path": "ua"
      },
      "en": {
        "label": "English",
        "direction": "ltr",
        "htmlLang": "en-US",
        "calendar": "gregory"
      }
    },
    "path": "i18n"
  },
  "headTags": [
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/png",
        "sizes": "32x32",
        "href": "/img/favicon-32x32.png"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/png",
        "sizes": "16x16",
        "href": "/img/favicon-16x16.png"
      }
    },
    {
      "tagName": "noscript",
      "attributes": {},
      "innerHTML": "\n        <img height=\"1\" width=\"1\" style=\"display:none\"\n          src=\"https://www.facebook.com/tr?id=994272692834568&ev=PageView&noscript=1\"/>\n      "
    }
  ],
  "markdown": {
    "mermaid": true,
    "format": "mdx",
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    }
  },
  "themes": [
    "@docusaurus/theme-mermaid"
  ],
  "presets": [
    [
      "@docusaurus/preset-classic",
      {
        "docs": {
          "path": "docs",
          "sidebarPath": "./sidebars.ts",
          "sidebarCollapsible": true
        },
        "blog": {
          "path": "blog",
          "showReadingTime": true,
          "blogSidebarCount": "ALL",
          "blogSidebarTitle": "All our posts",
          "postsPerPage": "ALL",
          "feedOptions": {
            "type": null
          }
        },
        "sitemap": {
          "changefreq": "weekly",
          "priority": 0.5,
          "ignorePatterns": [
            "/tags/**"
          ]
        },
        "theme": {
          "customCss": [
            "/vercel/path0/src/css/custom.css"
          ]
        },
        "gtag": {
          "trackingID": "G-QWGMMVZT3B",
          "anonymizeIP": true
        }
      }
    ]
  ],
  "future": {
    "experimental_faster": {
      "swcJsLoader": true,
      "swcJsMinimizer": true,
      "swcHtmlMinimizer": true,
      "lightningCssMinimizer": true,
      "rspackBundler": true,
      "mdxCrossCompilerCache": true
    },
    "experimental_storage": {
      "type": "localStorage",
      "namespace": false
    },
    "experimental_router": "browser"
  },
  "themeConfig": {
    "mermaid": {
      "theme": {
        "light": "neutral",
        "dark": "dark"
      },
      "options": {}
    },
    "colorMode": {
      "disableSwitch": true,
      "defaultMode": "light",
      "respectPrefersColorScheme": false
    },
    "announcementBar": {
      "id": "evm-crawler-released-2025",
      "content": "<strong>EVM Crawler is now available!</strong> 🚀 <a href=\"/blog/introducing-evm-crawler\" target=\"_blank\" rel=\"noopener\" style=\"text-decoration: underline; font-weight: bold;\">See what's new →</a>",
      "backgroundColor": "#22d3ee",
      "textColor": "#ffffff",
      "isCloseable": false
    },
    "navbar": {
      "title": "EasyLayer",
      "logo": {
        "alt": "EasyLayer Logo",
        "src": "img/logo.png",
        "href": "https://easylayer.io/",
        "target": "_self"
      },
      "items": [
        {
          "type": "doc",
          "docId": "overview/intro",
          "label": "Docs",
          "className": "navbar-item-docs",
          "position": "left"
        },
        {
          "to": "/blog",
          "label": "Blog",
          "position": "left"
        },
        {
          "to": "/proof",
          "label": "Proof",
          "position": "left"
        },
        {
          "to": "/why",
          "label": "Why",
          "position": "left"
        },
        {
          "href": "https://github.com/easylayer/core/discussions",
          "label": "Discussions",
          "position": "right"
        },
        {
          "href": "https://github.com/easylayer",
          "className": "navbar-item-github",
          "position": "right"
        },
        {
          "type": "custom-smartLocaleDropdown",
          "position": "right",
          "dropdownItemsAfter": []
        }
      ],
      "hideOnScroll": false
    },
    "footer": {
      "style": "dark",
      "links": [
        {
          "title": "Docs",
          "items": [
            {
              "label": "Overview",
              "to": "/docs/overview"
            },
            {
              "label": "Quickstart",
              "to": "/docs/quickstart"
            },
            {
              "label": "First Custom Model",
              "to": "/docs/first-custom-model"
            },
            {
              "label": "Bitcoin Crawler",
              "to": "/docs/get-started/bitcoin-crawler"
            },
            {
              "label": "Transport SDK",
              "to": "/docs/get-started/transport-sdk"
            },
            {
              "label": "Proof",
              "to": "/proof"
            },
            {
              "label": "Why EasyLayer",
              "to": "/why"
            }
          ]
        },
        {
          "title": "Community",
          "items": [
            {
              "label": "Blog",
              "to": "/blog"
            },
            {
              "label": "Discussion",
              "href": "https://github.com/easylayer/core/discussions"
            },
            {
              "label": "GitHub",
              "href": "https://github.com/easylayer"
            }
          ]
        },
        {
          "title": "Company",
          "items": [
            {
              "label": "Privacy Policy",
              "to": "policy"
            },
            {
              "label": "Security Policy",
              "to": "security"
            },
            {
              "label": "Terms & Conditions",
              "to": "terms"
            },
            {
              "label": "Licenses",
              "to": "licenses"
            }
          ]
        }
      ],
      "copyright": "Copyright © 2026 EasyLayer Team"
    },
    "prism": {
      "defaultLanguage": "typescript",
      "additionalLanguages": [
        "bash",
        "shell-session",
        "docker",
        "log",
        "diff",
        "json"
      ],
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#9CDCFE",
          "backgroundColor": "#1E1E1E"
        },
        "styles": [
          {
            "types": [
              "prolog"
            ],
            "style": {
              "color": "rgb(0, 0, 128)"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(106, 153, 85)"
            }
          },
          {
            "types": [
              "builtin",
              "changed",
              "keyword",
              "interpolation-punctuation"
            ],
            "style": {
              "color": "rgb(86, 156, 214)"
            }
          },
          {
            "types": [
              "number",
              "inserted"
            ],
            "style": {
              "color": "rgb(181, 206, 168)"
            }
          },
          {
            "types": [
              "constant"
            ],
            "style": {
              "color": "rgb(100, 102, 149)"
            }
          },
          {
            "types": [
              "attr-name",
              "variable"
            ],
            "style": {
              "color": "rgb(156, 220, 254)"
            }
          },
          {
            "types": [
              "deleted",
              "string",
              "attr-value",
              "template-punctuation"
            ],
            "style": {
              "color": "rgb(206, 145, 120)"
            }
          },
          {
            "types": [
              "selector"
            ],
            "style": {
              "color": "rgb(215, 186, 125)"
            }
          },
          {
            "types": [
              "tag"
            ],
            "style": {
              "color": "rgb(78, 201, 176)"
            }
          },
          {
            "types": [
              "tag"
            ],
            "languages": [
              "markup"
            ],
            "style": {
              "color": "rgb(86, 156, 214)"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "rgb(212, 212, 212)"
            }
          },
          {
            "types": [
              "punctuation"
            ],
            "languages": [
              "markup"
            ],
            "style": {
              "color": "#808080"
            }
          },
          {
            "types": [
              "function"
            ],
            "style": {
              "color": "rgb(220, 220, 170)"
            }
          },
          {
            "types": [
              "class-name"
            ],
            "style": {
              "color": "rgb(78, 201, 176)"
            }
          },
          {
            "types": [
              "char"
            ],
            "style": {
              "color": "rgb(209, 105, 105)"
            }
          }
        ]
      },
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "image": "img/el_twitter_default.png",
    "metadata": [
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },
      {
        "name": "twitter:site",
        "content": "@easylayer_io"
      },
      {
        "name": "twitter:creator",
        "content": "@easylayer_io"
      },
      {
        "name": "twitter:title",
        "content": "EasyLayer.io"
      },
      {
        "name": "twitter:description",
        "content": "Self-hosted blockchain state services and custom indexers for developers."
      },
      {
        "name": "twitter:image",
        "content": "https://easylayer.io/img/el_twitter_default.png"
      },
      {
        "name": "description",
        "content": "Self-hosted blockchain state services and custom indexers for developers."
      },
      {
        "name": "keywords",
        "content": "blockchain state service, blockchain indexer, self hosted, event sourcing, CQRS, bitcoin, ethereum, TypeScript"
      },
      {
        "name": "author",
        "content": "EasyLayer Team"
      },
      {
        "name": "robots",
        "content": "index, follow"
      },
      {
        "property": "og:type",
        "content": "website"
      },
      {
        "property": "og:title",
        "content": "EasyLayer.io"
      },
      {
        "property": "og:description",
        "content": "Self-hosted blockchain state services and custom indexers for developers."
      },
      {
        "property": "og:image",
        "content": "https://easylayer.io/img/el_twitter_default.png"
      },
      {
        "property": "og:url",
        "content": "https://easylayer.io"
      },
      {
        "property": "og:site_name",
        "content": "EasyLayer.io"
      }
    ],
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "plugins": [
    [
      null,
      {
        "siteBaseUrl": "/",
        "blogRouteBasePath": "blog",
        "docsRouteBasePath": "docs"
      }
    ],
    null,
    null,
    null
  ],
  "scripts": [
    {
      "src": "https://connect.facebook.net/en_US/fbevents.js",
      "async": true,
      "defer": true
    },
    {
      "src": "/js/fb-pixel-init.js",
      "head": true
    }
  ],
  "baseUrlIssueBanner": true,
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false
};
